import React, { Component } from 'react'

export default class ProductDeposit extends Component {
    render() {

        let depositContents = <div className="blank_rating"></div>

        if (this.props.deposit) {
            depositContents = (
                <div className="review_stars">
                    {/* <img src={require(`../../images/ratings/star-${this.props.rating}.png`)} alt={`${this.props.rating} out of 5`} /> */}
                    Deposit: {this.props.deposit}
                    {/* <img src={`/images/ratings/star-${this.props.rating}.png`} alt={`${this.props.rating} out of 5`} /> */}
                </div>
            )
        }

        return (
            depositContents
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/product/ProductDeposit.js